import { API } from '../utils'

export const getUsers = async ({ params }) => {
  const response = API.get('/organization/users', { params })
  const data = await response
  return data
}

export const getUsersExcel = async ({ params }) => {
  const response = API.get('/organization/users/excel/export', { params })
  const data = await response
  return data
}

export const createUser = async ({ body }) => {
  const response = API.post('/organization/users', body)
  const data = await response
  return data
}

/* Invites a pasted list of mobile numbers in one request. The response splits
 * them into `invited` and `skipped` (with a reason each), so the caller can say
 * what actually happened instead of claiming every number went through. */
export const bulkInviteUsers = async ({ body }) => {
  const response = API.post("/organization/users/bulk", body);
  const data = await response;
  return data;
};

export const deleteUser = async ({ params }) => {
  const response = API.delete(`/organization/users/${params.id}`, { params })
  const data = await response
  return data
}

export const getSingleUser = async ({ params }) => {
  const response = API.get(`/organization/users/${params.id}`, { params })
  const data = await response
  return data
}

export const updateUser = async ({ params, body }) => {
  const response = API.patch(`/organization/users/${params.id}`, body)
  const data = await response
  return data
}

/* تغییر ایمیل یا شماره همراهِ خودِ کاربر، در دو قدم. عمداً جدا از
 * `updateMyProfile`: سرور هم دیگر این دو فیلد را از `PATCH /auth/profile`
 * نمی‌پذیرد، چون بدون تأیید نباید روی حساب بنشینند. */
export const requestContactChange = async ({ body }) => {
  const response = API.post("/auth/profile/contact/request", body);
  const data = await response;
  return data;
};

export const verifyContactChange = async ({ body }) => {
  const response = API.post("/auth/profile/contact/verify", body);
  const data = await response;
  return data;
};

export const updateMyProfile = async ({ body }) => {
  const response = API.patch("/auth/profile", body);
  const data = await response;
  return data;
};


export const restoreUser = async ({ params }) => {
  const response = API.put(`/organization/users/${params.id}/restore`)
  const data = await response
  return data
}

/* آواتارِ خودِ کاربر. مسیرِ `organization/users/{uuid}/media` پشتِ دسترسیِ
 * «مدیریت کاربران» است، پس عضو عادی برای عوض کردن عکسِ خودش هم ۴۰۳ می‌گرفت.
 * این یکی زیر `auth` است و روی `auth()->user()` کار می‌کند — همان کسی که
 * درخواست را فرستاده، نه یک uuid که باید اجازه‌اش را داشته باشی. */
export const uploadMyMedia = async ({ body, onUploadProgress }) => {
  const response = API.post("/auth/media", body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    timeout: 120000,
  });
  const data = await response;
  return data;
};

export const deleteMyMedia = async ({ params }) => {
  const response = API.delete(`/auth/media/${params.media}`);
  const data = await response;
  return data;
};

export const uploadUserMedia = async ({ params, body, onUploadProgress }) => {
  const response = API.post(`/organization/users/${params.user}/media`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
    timeout: 120000
  })
  const data = await response
  return data
}

export const deleteUserMedia = async ({ params }) => {
  const response = API.delete(
    `/organization/users/${params.user}/media/${params.media}`
  );
  const data = await response;
  return data;
};